'use strict';

module.exports = {
    WIDTH: 800,
    HEIGHT: 400,
    RENDER_ID: 'game-area',
};
